import { useEffect, useState } from "react";

/**
 * Giá trị chậm lại `delayMs` sau lần gõ cuối.
 *
 * Dùng cho những việc tốn kém mỗi lần gõ một phím — gọi ra mạng, lọc danh sách
 * dài. Người gõ dở mã số thuế không đáng bị gọi mười lượt tra cứu.
 */
export function useDebounce<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
